/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const scopeSizeResponseSchema = z.object({
  count: z.int(),
  limit: z.int().nullish(),
});
